import { render, staticRenderFns } from "./thirdparty.vue?vue&type=template&id=87a6294a&scoped=true"
import script from "./thirdparty.vue?vue&type=script&lang=js"
export * from "./thirdparty.vue?vue&type=script&lang=js"
import style0 from "./thirdparty.vue?vue&type=style&index=0&id=87a6294a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a6294a",
  null
  
)

export default component.exports